import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from '../../../core/services/chat.service';
import { EducationalForumTextService } from '../../../core/services/educational-forum-text.service';
import { EducationalForumService } from '../../../core/services/educational-forum.service';
import { AppErrorShow } from '../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../core/utils/global-name';
import { LocalStorageService } from '../../../core/utils/local-stoarge-service';
import { LoadingComponent } from '../loading/loading.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-educational-forum-list',
    templateUrl: './educational-forum-list.component.html',
    imports: [CommonModule, LoadingComponent, FormsModule],
    styleUrls: ['./educational-forum-list.component.css']
})
export class EducationalForumListComponent {
  @Input('classrooms') classrooms:any[]=[]
  @Input('forStudent') forStudent:any=false
  message: string=""
  messages: string[] = [];

  vue="list"
  buttonsPermission :any|undefined;
 search_text=""
  roles:any[] =[]
  data:any[] =[]
  fora:any[] =[]
  texts:any[] =[]
  ays:any[] =[]
  selected_data:any;
  modalOption:any; 
  fileInput:any; 
  classroomId:any
  ayId:any
  currentId:any
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="sauvegardes"
  text=""
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any


  constructor(
    private chatService: ChatService,
    private efService:EducationalForumService,
    private eftService:EducationalForumTextService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.chatService.getMessages().subscribe((res: any) => {
      this.messages.push(res.message);
    });
    this.init()
    this.getActions()
    this.user=this.lsService.get(GlobalName.userName)

  }

  init(){
    if(this.forStudent){
      this.getEducationalForaForStudent()
    }
  }

  sendMessage() {
    this.chatService.sendMessage(this.message);
    this.message = '';
  }
  
  sendText(){
    this.eftService.store({
      ef_id:this.currentId,
      sender_id:this.user.id,
      texte:this.text
    }).subscribe((res:any)=>{
      this.text=""
      this.loadText(this.currentId)
    },
    (err:any)=>{
AppErrorShow.showError("Foras",err)
    })
  }
 

  getEducationalFora(){
    this.efService.getByProfessorClassroom(this.classroomId).subscribe((res:any)=>{
      this.fora=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Foras",err)
    })
  }
  getEducationalForaForStudent(){
    this.efService.getForStudent().subscribe((res:any)=>{
      this.fora=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Foras",err)
    })
  }

  loadText(id:any){
    this.currentId=id
    this.eftService.getAll(id).subscribe((res:any)=>{
      this.texts=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Foras",err)
    })
  }

  

  loadlist1(e:any){
    this.classroomId=e.target.value
      this.getEducationalFora()
    
   
  }
  


  store(value:any){
    this.loading=true

    
    this.efService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.getEducationalFora()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Foras",err)

    })
  }
  update(value:any){
    this.loading=true

    this.efService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Foras",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.efService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Foras",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.efService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Foras",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }



  changeView(event:any){
    this.vue=event.target.value
  }

  upload(ev:any){
    if (ev.target.files.length!=0) {
      this.fileInput=ev.target.files[0]
    }
  }
}
